import { Controller } from "@hotwired/stimulus"

// Theme switcher. The layout's inline <head> script has already stamped <html data-theme> from
// localStorage (or the OS preference) before first paint; this controller only handles changes.
// Dispatches "theme:change" on window so charts can recolor.
export default class extends Controller {
  static targets = ["label", "sun", "moon"]
  static values = { choice: String }   // "light" | "dark" | "system"

  connect() {
    this.choiceValue = this.stored() || "system"
    this.media = window.matchMedia("(prefers-color-scheme: dark)")
    this.onMedia = () => { if (this.choiceValue === "system") this.apply() }
    this.media.addEventListener("change", this.onMedia)
    this.render()
  }

  disconnect() { this.media.removeEventListener("change", this.onMedia) }

  // Cycles light → dark → system.
  toggle() {
    const next = { light: "dark", dark: "system", system: "light" }[this.choiceValue] || "light"
    this.choiceValue = next
    try { next === "system" ? localStorage.removeItem("theme") : localStorage.setItem("theme", next) } catch (_) {}
    this.apply()
    this.render()
  }

  apply() {
    const resolved = this.choiceValue === "system" ? (this.media.matches ? "dark" : "light") : this.choiceValue
    document.documentElement.dataset.theme = resolved
    window.dispatchEvent(new CustomEvent("theme:change", { detail: { theme: resolved } }))
  }

  render() {
    const label = { light: "Light", dark: "Dark", system: "System" }[this.choiceValue]
    if (this.hasLabelTarget) this.labelTarget.textContent = label
    const dark = document.documentElement.dataset.theme === "dark"
    if (this.hasSunTarget) this.sunTarget.hidden = dark
    if (this.hasMoonTarget) this.moonTarget.hidden = !dark
  }

  stored() { try { return localStorage.getItem("theme") } catch (_) { return null } }
}
